import React, { useEffect } from 'react';
import { Box } from '@wix/design-system';
import s from '../styles/Categories.scss';
import { useSetSelectedCategory, useSetUserEmailAddress } from '../../../store/appStore';
import { Footer } from '../../../components/Footer';
import { useVisibleCategories } from '../hooks/useVisibleCateogries';
import { useSaveCategoryValue } from '../hooks/useSaveCategoryValue';
import { MobileCategoriesSelector } from './MobileCategoriesSelector';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { TEMPLATE_SELECTION_URL } from '../../../consts';
import { CATEGORIES } from '@common/constants/categories';

export function MobileCategories() {
  const { saveCategoryValue, isLoading, categoryValue } = useSaveCategoryValue();
  const setCategoryValue = useSetSelectedCategory();
  const visibleCategories = useVisibleCategories({});
  const { navigate } = useAppNavigation();
  const setUserEmailAddress = useSetUserEmailAddress();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const categoryParam = params.get('categoryId');
    const [rawCategoryId, userEmailAddress] = categoryParam?.split('^') ?? [];
    if (userEmailAddress) {
      setUserEmailAddress(userEmailAddress);
    }
    if (rawCategoryId) {
      // Extract category from format "lang.rts.category" (e.g., "pt.rts.kidsBabies" -> "rts.kidsBabies")
      const langMatch = rawCategoryId.match(/^[a-z]{2}\.(rts\..+)$/i);
      const categoryId = langMatch ? langMatch[1] : rawCategoryId;

      if (categoryId in CATEGORIES) {
        setCategoryValue(categoryId);
        // Allow Zustand persist middleware to write to sessionStorage before navigating
        requestAnimationFrame(() => {
          navigate(TEMPLATE_SELECTION_URL);
        });
      }
    }
  }, [navigate, setCategoryValue, setUserEmailAddress]);

  return (
    <Box className={s.card} height="100%">
      <Box direction="vertical" height="100%" gap={2}>
        <MobileCategoriesSelector
          categories={visibleCategories}
          selectedCategory={categoryValue}
          onCategorySelect={setCategoryValue}
        />

        <Footer isDisabled={!categoryValue || isLoading} onClick={saveCategoryValue} />
      </Box>
    </Box>
  );
}
